import React, { useEffect, useState } from 'react';

import { useQueryClient } from 'react-query';

import { useVersionStore } from 'store/version.store';

import { queryKey } from 'api/queries/getSchedulingSimulationResults.query';

import { IRowsBoard } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import { Button } from 'components/DesignSystem/Button';
import { useSimulatedActivitiesFiltersStore } from 'components/widgets/ScheduleSimulation/components/SimulatedActivitiesTable/SimulatedActivitiesFilter/simulatedActivitiesFilter.store';
import classes from 'components/widgets/ScheduleSimulation/components/SimulatedActivitiesTable/SimulatedActivitiesTable.module.scss';
import { SimulatedActivitiesTabs } from 'components/widgets/ScheduleSimulation/components/SimulatedActivitiesTable/SimulatedActivityTabs/simulatedActivitiesTabs';
import SimulatedTaskActivitiesTable from 'components/widgets/ScheduleSimulation/components/SimulatedActivitiesTable/SimulatedTaskActivitiesTable/SimulatedTaskActivitiesTable';
import SimulatedWbsTable from 'components/widgets/ScheduleSimulation/components/SimulatedActivitiesTable/SimulatedWbsTable/SimulatedWbsTable';
import { SimulationNote } from 'components/widgets/ScheduleSimulation/components/SimulatedActivitiesTable/SimulationNote/SimulationNote';
import { useSimulationCacheKeyStore } from 'components/widgets/ScheduleSimulation/components/SimulatedActivitiesTable/simulationCacheKey.store';
import {
    SettingsAndWarnings,
    SimulationWarning,
} from 'components/widgets/ScheduleSimulation/components/SimulationWarning/SimulationWarning';

interface Props extends Omit<IRowsBoard, 'filterData'> {
    simulationDate: number;
    handleBackClick: () => void;
}

const SimulatedTables = ({ projectId, contractId, handleBackClick, simulationDate }: Props) => {
    const currentVersion = useVersionStore((state) => state.version);
    const metaDataId = currentVersion?.id as number;
    const [notification, setNotification] = useState<SettingsAndWarnings | null>(null);
    const [note, setNote] = useState<string>('');
    const { activeTab } = useSimulatedActivitiesFiltersStore();
    const { resetSimulationSession, cacheIsReady } = useSimulationCacheKeyStore();
    const queryClient = useQueryClient();

    useEffect(() => {
        return () => {
            resetSimulationSession();
            queryClient.removeQueries({ queryKey, exact: false });
        };
    }, []);

    return (
        <>
            {cacheIsReady && notification && <SimulationWarning notification={notification} />}
            {cacheIsReady && note && <SimulationNote note={note} />}
            <SimulatedActivitiesTabs />

            {activeTab === 'wbs' && (
                <SimulatedWbsTable
                    projectId={projectId}
                    contractId={contractId}
                    simulationDate={simulationDate}
                    metaDataId={metaDataId}
                    setNote={setNote}
                    setNotification={setNotification}
                />
            )}
            {activeTab === 'activities' && (
                <SimulatedTaskActivitiesTable
                    projectId={projectId}
                    contractId={contractId}
                    simulationDate={simulationDate}
                    metaDataId={metaDataId}
                    setNote={setNote}
                    setNotification={setNotification}
                />
            )}

            <div className={classes.footer}>
                <Button size={'large'} variant={'secondary'} onClick={handleBackClick}>
                    Back
                </Button>
            </div>
        </>
    );
};

export default React.memo(SimulatedTables);
